/* VaultRx theme JS — no dependencies. */
(function () {
  'use strict';

  function money(cents) {
    var fmt = (window.VRX && window.VRX.moneyFormat) || '${{amount}}';
    var val = (cents / 100).toFixed(2);
    if (fmt.indexOf('amount_no_decimals') > -1) val = Math.round(cents / 100).toString();
    if (fmt.indexOf('amount_with_comma_separator') > -1) val = val.replace('.', ',');
    val = val.replace(/\B(?=(\d{3})+(?!\d))/g, fmt.indexOf('comma_separator') > -1 ? '.' : ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, val);
  }

  /* ---- mobile menu ---- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = nav.hasAttribute('open');
      if (open) nav.removeAttribute('open'); else nav.setAttribute('open', '');
      btn.setAttribute('aria-expanded', String(!open));
    });
  });


  /* ---- in-page anchors: if a menu link points at a section that exists on THIS page, scroll to it instead of leaving ---- */
  document.querySelectorAll('a[href*="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href') || '';
      var hash = href.split('#')[1];
      if (!hash) return;
      var target = document.getElementById(hash);
      if (!target) return;
      e.preventDefault();
      document.querySelectorAll('.mobile-nav[open]').forEach(function (n) { n.removeAttribute('open'); });
      document.querySelectorAll('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) window.history.replaceState({}, '', '#' + hash);
    });
  });


  /* ---- mobile carousels: subtle dots under every horizontal rail ---- */
  (function () {
    var RAILS = '.rail,.steps,.bento,.tiles,.rrail,.px-cards4,.px-st3,.px-who3,.px-fb3';
    var mq = window.matchMedia('(max-width: 900px)');
    function build(rail, always) {
      if (rail.__dots || rail.children.length < 2) return;
      var wrap = document.createElement('div'); wrap.className = always ? 'rail-nav rail-nav--always' : 'rail-nav'; wrap.setAttribute('aria-hidden', 'true');
      var dots = document.createElement('div'); dots.className = 'rail-dots';
      Array.prototype.forEach.call(rail.children, function (card, i) {
        var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Go to item ' + (i + 1));
        d.addEventListener('click', function () { rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: 'smooth' }); });
        dots.appendChild(d);
      });
      function arrow(dir) { var b = document.createElement('button'); b.type = 'button'; b.className = 'rail-arr'; b.setAttribute('aria-label', dir < 0 ? 'Previous' : 'Next'); b.innerHTML = dir < 0 ? '&#8249;' : '&#8250;'; b.addEventListener('click', function () { var w = rail.children[0].getBoundingClientRect().width + (always ? 18 : 12); rail.scrollBy({ left: dir * w, behavior: 'smooth' }); }); return b; }
      var prev = arrow(-1), next = arrow(1);
      wrap.appendChild(prev); wrap.appendChild(dots); wrap.appendChild(next);
      rail.parentNode.insertBefore(wrap, rail.nextSibling);
      rail.__dots = wrap;
      function update() {
        var max = rail.scrollWidth - rail.clientWidth; if (max <= 0) { wrap.hidden = true; return; } wrap.hidden = false;
        var pct = rail.scrollLeft / max;
        var n = rail.children.length, idx = Math.round(pct * (n - 1));
        Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
        prev.disabled = rail.scrollLeft < 4; next.disabled = rail.scrollLeft > max - 4;
      }
      rail.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
    }
    function init() {
      document.querySelectorAll('[data-rail-nav="always"]').forEach(function (r) { build(r, true); });
      if (!mq.matches) return; document.querySelectorAll(RAILS).forEach(function (r) { build(r, false); });
    }
    init(); if (mq.addEventListener) mq.addEventListener('change', init); else mq.addListener(init);
  })();


  /* ---- rotating announcement bar ---- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.ann__item'); if (items.length < 2) return;
    var i = 0, ms = (parseInt(bar.getAttribute('data-interval'), 10) || 4) * 1000, timer;
    function show(n) { items[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); }
    function start() { stop(); timer = setInterval(function () { show(i + 1); }, ms); }
    function stop() { if (timer) clearInterval(timer); }
    var prev = bar.querySelector('[data-ann-prev]'), next = bar.querySelector('[data-ann-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  });

  /* ---- UGC video rail: autoplay muted when visible, tap the speaker to unmute one at a time ---- */
  document.querySelectorAll('[data-video-rail]').forEach(function (rail) {
    var vids = rail.querySelectorAll('[data-vx-video]'); if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { var v = e.target; if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { io.observe(v); });
    } else { vids.forEach(function (v) { v.play().catch(function () {}); }); }
    rail.querySelectorAll('[data-vx-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentElement.querySelector('video'); if (!v) return;
        var unmute = v.muted;
        vids.forEach(function (o) { o.muted = true; o.parentElement.classList.remove('is-sound'); });
        v.muted = !unmute; v.parentElement.classList.toggle('is-sound', !v.muted);
        if (!v.muted) v.play().catch(function () {});
      });
    });
  });

  /* ---- cart count ---- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    var link = document.getElementById('CartLink');
    if (link) link.setAttribute('aria-label', 'Cart, ' + n + ' items');
  }

  /* ---- product section ---- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('[data-product-form]');
    var variantsEl = section.parentElement.querySelector('[data-variants]') || document.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = section.querySelector('[data-variant-id]');
    var sticky = document.querySelector('[data-sticky-bar]');
    if (sticky && 'IntersectionObserver' in window) {
      var buyBox = section.querySelector('.px-buy') || section;
      new IntersectionObserver(function (es) { es.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }); }, { threshold: 0 }).observe(buyBox);
    } else if (sticky) { sticky.classList.add('is-visible'); }
    var priceEls = Array.prototype.slice.call(section.querySelectorAll('[data-price]')).concat(sticky ? Array.prototype.slice.call(sticky.querySelectorAll('[data-price]')) : []);
    var compareEl = section.querySelector('[data-compare-price]');
    var saveEl = section.querySelector('[data-save]');
    var addBtns = Array.prototype.slice.call(section.querySelectorAll('[data-add-to-cart]')).concat(sticky ? Array.prototype.slice.call(sticky.querySelectorAll('[data-add-to-cart]')) : []);
    var addTexts = Array.prototype.slice.call(section.querySelectorAll('[data-add-text]')).concat(sticky ? Array.prototype.slice.call(sticky.querySelectorAll('[data-add-text]')) : []);
    var addBtn = { set disabled(v) { addBtns.forEach(function (b) { b.disabled = v; }); } };
    var addText = { set textContent(v) { addTexts.forEach(function (t) { t.textContent = v; }); }, get textContent() { return addTexts[0] ? addTexts[0].textContent : ''; } };
    var priceEl = { set textContent(v) { priceEls.forEach(function (p) { p.textContent = v; }); } };
    var msg = section.querySelector('[data-form-msg]');
    var mainImg = section.querySelector('[data-main-image]') || document.getElementById('MainImage');
    var defaultAddLabel = addText ? addText.textContent : 'Add to cart';
    var bundleName = section.getAttribute('data-bundle-option') || 'Bundle';
    var planPrice = parseInt(section.getAttribute('data-plan-price') || '0', 10);
    var currentVariant = null;
    function q(sel) { return section.querySelector(sel); }
    function unitsOf(v) { var m = /^(\d+)/.exec(v || ''); return m ? parseInt(m[1], 10) : 1; }
    function planSelected() { var p = q('[data-plan-input]:checked'); return p && p.value ? p.value : null; }
    function bundleIndex() { var seg = q('[data-bundle-seg]'); return seg ? parseInt(seg.getAttribute('data-option-index'), 10) : -1; }
    function refreshBundleCards(v, bi) {
      var rail = q('[data-bundle-seg]');
      if (!rail || bi < 0 || !v) return;
      var inputs = rail.querySelectorAll('input[data-option-input]');
      /* the single-unit variant on the same colour is the per-unit reference */
      var single = variants.find(function (x) {
        return unitsOf(x.options[bi]) === 1 && x.options.every(function (o, i) { return i === bi || o === v.options[i]; });
      });
      inputs.forEach(function (input) {
        var card = rail.querySelector('label[for="' + input.id + '"]');
        if (!card) return;
        var match = variants.find(function (x) {
          return x.options[bi] === input.value && x.options.every(function (o, i) { return i === bi || o === v.options[i]; });
        });
        var totalEl = card.querySelector('[data-bcard-total]');
        var unitEl = card.querySelector('[data-bcard-unit]');
        var saveEl3 = card.querySelector('[data-bcard-save]');
        if (!match) {
          if (totalEl) totalEl.textContent = '—';
          if (unitEl) unitEl.textContent = '';
          if (saveEl3) saveEl3.hidden = true;
          card.classList.add('is-out');
          return;
        }
        card.classList.remove('is-out');
        var units = unitsOf(match.options[bi]) || 1;
        if (totalEl) totalEl.textContent = money(match.price);
        if (unitEl) unitEl.textContent = units > 1 ? money(Math.round(match.price / units)) + ' each' : 'per unit';
        if (saveEl3) {
          var saved = single ? single.price * units - match.price : 0;
          if (units > 1 && saved > 0) { saveEl3.textContent = 'Save ' + money(saved).replace(/\.00$/, ''); saveEl3.hidden = false; }
          else { saveEl3.hidden = true; }
        }
      });
    }

    function refreshExtras(v) {
      if (!v) return;
      var bi = bundleIndex();
      var units = bi > -1 ? unitsOf(v.options[bi]) : 1;
      var unitEl = q('[data-unit-price]'); if (unitEl) unitEl.textContent = money(Math.round(v.price / units));
      var saveEl2 = q('[data-bundle-save]');
      if (saveEl2) {
        var single = null;
        if (bi > -1) single = variants.find(function (x) { return unitsOf(x.options[bi]) === 1 && x.options.every(function (o, i) { return i === bi || o === v.options[i]; }); });
        var saved = single ? single.price * units - v.price : 0;
        if (units > 1 && saved > 0) { saveEl2.textContent = 'SAVE ' + money(saved).replace(/\.00$/, ''); saveEl2.hidden = false; } else { saveEl2.hidden = true; }
      }
      var bestEl = q('[data-bundle-best]'); var checked = q('[data-bundle-seg] input:checked');
      if (bestEl && checked && checked.getAttribute('data-best')) bestEl.textContent = checked.getAttribute('data-best');
      refreshBundleCards(v, bi);
      var base = q('[data-plan-base]'); if (base) base.textContent = money(v.price);
      var tot = q('[data-plan-total]'); if (tot) tot.textContent = money(v.price + planPrice);
      var pc = q('[data-plan-compare]'); var planCmp = parseInt(section.getAttribute('data-plan-compare') || '0', 10); if (pc && planCmp) pc.textContent = money(v.price + planCmp);
      var withPlan = planSelected() ? v.price + planPrice : v.price;
      priceEls.forEach(function (p) { p.textContent = money(withPlan); });
    }

    function selectedOptions() {
      var groups = section.querySelectorAll('[data-option-index]');
      var out = [];
      groups.forEach(function (g) {
        if (g.tagName === 'SELECT') out.push(g.value);
        else { var c = g.querySelector('input:checked'); out.push(c ? c.value : null); }
      });
      return out;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function render(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl && saveEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false;
          saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; saveEl.hidden = false;
        } else { compareEl.hidden = true; saveEl.hidden = true; }
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? defaultAddLabel : 'Sold out';
      if (v.featured_image && v.featured_image.src && mainImg) {
        mainImg.src = v.featured_image.src; mainImg.removeAttribute('srcset');
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      currentVariant = v;
      refreshExtras(v);
    }
    /* initial state */
    (function () { var v0 = findVariant(selectedOptions()); if (v0) { currentVariant = v0; refreshExtras(v0); } else if (idInput && variants.length) { currentVariant = variants.find(function (x) { return String(x.id) === String(idInput.value); }) || null; if (currentVariant) refreshExtras(currentVariant); } })();
    section.querySelectorAll('[data-plan-input]').forEach(function (r) { r.addEventListener('change', function () { if (currentVariant) refreshExtras(currentVariant); }); });

    section.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () { render(findVariant(selectedOptions())); });
    });

    /* quantity */
    var qty = section.querySelector('[data-qty-input]');
    var minus = section.querySelector('[data-qty-minus]');
    var plus = section.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    /* thumbnails */
    section.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (mainImg) { mainImg.src = btn.getAttribute('data-thumb'); mainImg.removeAttribute('srcset'); }
        section.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });

    /* AJAX add to cart (+ optional plan add-on, + buy now) */
    function addToCart(goCheckout) {
      if (msg) { msg.textContent = ''; msg.classList.remove('is-visible'); }
      addBtn.disabled = true;
      addText.textContent = 'Adding…';
      var qtyEl = form.querySelector('[name="quantity"]');
      var items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyEl ? qtyEl.value : '1', 10) || 1 }];
      var plan = planSelected(); if (plan) items.push({ id: parseInt(plan, 10), quantity: 1 });
      fetch(window.VRX.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          return fetch(window.VRX.routes.cart + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          addText.textContent = 'Added ✓';
          setTimeout(function () { window.location.href = goCheckout ? '/checkout' : window.VRX.routes.cart; }, 300);
        })
        .catch(function (err) {
          if (msg) { msg.textContent = err.message; msg.classList.add('is-visible'); }
          addBtn.disabled = false;
          addText.textContent = defaultAddLabel;
        });
    }
    if (form && window.VRX && idInput) {
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(false); });
      var buyNow = section.querySelector('[data-buy-now]');
      if (buyNow) buyNow.addEventListener('click', function () { addToCart(true); });
    }
  });

  /* ---- cart page: live qty updates ---- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      fetch(window.VRX.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); });
    });
  });
})();
